module.exports = __webpack_public_path__ + "img/134.4.f48b9761.png";